export default {
  stateHere: false
}
